<div class="component-container player-stats"
     [class]="controlAction"
     [class.odm-away]="utilService.getTeamSide(player?.teamGuid, broadcast) === 'away'"
     [class.odm-home]="utilService.getTeamSide(player?.teamGuid, broadcast) === 'home'">
  <div class="image"
       [style.background-color]="getTeamBgr()"
  >
    <div class="team-img" [style]="getBgrWithOverlay()">
      <span class="team-code" *ngIf="utilService.hideTeamLogos(broadcast)">{{utilService.getTeamShortCode(player?.teamGuid, broadcast)}}</span>
    </div>
  </div>
  <div class="stats">
    <div class="name"
         [style.background-color]="getTeamBgr()">
      <div>{{getNumber()}} {{getName().toUpperCase()}}</div>
      <div class="position">
        {{utilService.positionToString(player?.position)}}
      </div>
    </div>
    <div class="data">
      <div *ngIf="player?.records?.length">
        <div>{{ broadcast?.config?.skinId === 'ODM' ? '' : 'Today' }}</div>
        <div>
          {{player?.gameStats?.batting?.h ? player.gameStats.batting.h : 0}}
          {{ broadcast?.config?.skinId === 'ODM' ? utilService.czOutOf(player?.gameStats?.batting?.ab ? player.gameStats.batting.ab : 0) : 'for' }}
          {{player?.gameStats?.batting?.ab ? player.gameStats.batting.ab : 0}}
        </div>
      </div>
      <ng-container *ngIf="player?.records?.length">
        <div *ngFor="let record of player.records">
          <div>{{record.inning}}</div>
          <div>{{record.play}}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="!player?.records?.length && player?.seasonStats?.batting?.ab">
        <div>
          <div>BA</div>
          <div>{{ formatAvg(player?.seasonStats?.batting?.ba) || '-' }}</div>
        </div>
        <div>
          <div>OBP</div>
          <div>{{ formatAvg(player?.seasonStats?.batting?.obp) || '-' }}</div>
        </div>
        <div>
          <div>HR</div>
          <div>{{ player?.seasonStats?.batting?.hr || '-' }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
